import React, { useState } from "react";

import {
  Button,
  Rating,
  Container,
  Tabs,
  Tab,
  Grid,
  Checkbox,
  Slider,
  InputLabel,
  Select,
  MenuItem,
  Pagination,
  TextField,
} from "@mui/material";
import {
  Favorite,
  FilterList,
  LocationOn,
  Search,
  Sort,
} from "@mui/icons-material";
import ReactHtmlParser from "react-html-parser";
import { BasicCard } from "components";
import { Reviews } from "pages";
import { useNavigate, useParams } from "react-router-dom";
import { onValue, ref, remove, set } from "firebase/database";
import { database } from "configs/firebaseConfigs";
import { useIsMounted } from "hooks";
import { useEffect } from "react";
import { useCartData, useProducts, useWishlistData } from "hooks/useDataFetch";
import Lottie from "react-lottie";
import { emptyList } from "asset/animations";
import { useAppContext } from "contexts";
import Swal from "sweetalert2";

const Distributors = () => {
  const [supplierDetails, setSuppliersDetails] = useState({});
  const [supplierProducts, setSuppliersProducts] = useState([]);

  const { supplierid } = useParams();
  const navigate = useNavigate();
  const isMounted = useIsMounted();
  const products = useProducts();
  const { user } = useAppContext();
  const wishList = useWishlistData();

  // console.log(supplierProducts);

  //get supplier data

  useEffect(() => {
    if (isMounted.current) {
      onValue(ref(database, `suppliers/${supplierid}`), (snapshot) => {
        if (snapshot.exists()) {
          // console.log(snapshot.val());
          setSuppliersDetails(snapshot.val());
        } else {
          navigate("/");
        }
      });
    }
  }, [supplierid, isMounted, navigate]);

  //get supplier products

  useEffect(() => {
    if (isMounted.current) {
      const supplierProduct = products?.data?.filter((item) => {
        return item.supplierId === supplierid;
      });
      setSuppliersProducts(supplierProduct);
    }
  }, [isMounted, products?.data, supplierid]);

  // console.log(supplierProducts);

  /////////////////////////tab navigation///////////////////////////////

  const [tabActive, setTabVActive] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabVActive(newValue);
  };

  function TabPanel(props) {
    const { children, value, index } = props;

    return (
      <div role="tabpanel" hidden={value !== index}>
        {value === index && <div>{children}</div>}
      </div>
    );
  }

  // function allProps(index) {
  //   return {
  //     id: `supplier-tab-${index}`,
  //     "aria-controls": `simple-tabpanel-${index}`,
  //   };
  // }

  /////////////////////////tab navigation finished  ///////////////////////////////

  //add to favorite

  const addToFavorite = () => {
    try {
      // console.log("add to favorite");
      if (!user.uid) {
        Swal.fire({
          title: "Please login to add to Favorites",
          icon: "warning",
        });
        return;
      }

      const favoriteData = {
        id: supplierid,
        type: "supplier",
        createdAt: Date.now(),
      };
      set(ref(database, `wishlist/${user?.uid}/${supplierid}`), favoriteData)
        .then(() => {
          Swal.fire({
            title: "Added to favorites",
            icon: "success",
          });
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Something Went Wrong. Try Again!",
            icon: "error",
          });
        });
    } catch (error) {
      console.log(error);
    }
  };

  //remove from favorite

  const removeFavorite = async () => {
    try {
      await remove(ref(database, `wishlist/${user?.uid}/${supplierid}`));
      Swal.fire({
        icon: "success",
        title: "Removed from favorites",
      });
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };

  return (
    <main className="supplier-page-main">
      <header className="supplier-page-header">
        <Container>
          <div className="supplier-details flex-row align-items-center justify-content-between">
            <div className="supplier-details-left flex-row align-items-center gap-1">
              <div className="supplier-details-logo">
                <img src={supplierDetails?.image} alt="" />
              </div>

              <div className="supplier-details-desc flex-column gap-1">
                <div className="supplier-details-rating">4.5 Rating</div>

                <div className="supplier-title">
                  <h3>{supplierDetails?.name}</h3>
                </div>

                <div className="supplier-details-rating-star">
                  <Rating
                    name="read-only"
                    value={parseInt(supplierDetails?.rating)}
                    readOnly
                  />
                </div>
                <div className="supplier-details-locations flex-row align-items-center gap-1 ">
                  <LocationOn /> <span>{supplierDetails?.location}</span>
                </div>
              </div>
            </div>
            <div className="supplier-details-right">
              <Button
                className="supplier-add-to-favorite-btn"
                endIcon={<Favorite />}
                onClick={() => {
                  wishList?.data?.some((item) => {
                    return item?.id === supplierid;
                  })
                    ? removeFavorite()
                    : addToFavorite();
                }}
              >
                {wishList?.data?.some((item) => {
                  return item?.id === supplierid;
                })
                  ? "Favorite Added"
                  : "Add to favorites"}
              </Button>
            </div>
          </div>
        </Container>
      </header>

      <section className="supplier-home-main-section">
        <div className="supplier-tab-nav">
          <Container>
            <Tabs
              value={tabActive}
              onChange={handleTabChange}
              aria-label="supplier-tab-navigation"
            >
              <Tab label="Products" className="supplier-tab-nav-items" />
              <Tab label="Reviews" className="supplier-tab-nav-items" />
              <Tab label="Info" className="supplier-tab-nav-items" />
            </Tabs>
          </Container>
        </div>
        <TabPanel value={tabActive} index={0}>
          <SupplierProducts products={products?.data} />
        </TabPanel>
        <TabPanel value={tabActive} index={1}>
          <Reviews
            id={supplierid}
            title={supplierDetails?.name}
            supplier={true}
          />
        </TabPanel>
        <TabPanel value={tabActive} index={2}>
          <SupplierInfo details={supplierDetails} />
        </TabPanel>
      </section>
    </main>
  );
};

export default Distributors;

const SupplierProducts = ({ products }) => {
  const [sortBy, setSortBy] = useState("recommended");

  // console.log(sortBy);

  const handleSort = (event) => {
    setSortBy(event.target.value);
  };

  const [ratingFilter, setRatingFilter] = useState(0);
  const [priceFilter, setPriceFilter] = useState(0);
  const [quantityFilter, setQuantityFilter] = useState(0);
  const [filterProduct, setFilterProduct] = useState([]);
  const [sortProduct, setSortProduct] = useState([]);

  const [filter, setFilter] = useState(false);
  const [sort, setSort] = useState(false);
  const [onSale, setOnSale] = useState(false);
  const [orderTypeIndividual, setOrderTypeIndividual] = useState(true);

  const wishList = useWishlistData();

  const cartData = useCartData();

  const isMounted = useIsMounted();

  // console.log(priceFilter);

  // console.log(products);

  // console.log(onSale);

  //filter products

  useEffect(() => {
    if (isMounted?.current) {
      const filterPrice = products?.filter((item) => {
        if (priceFilter < 1000 && priceFilter > 0) {
          return item.price <= priceFilter;
        } else if (priceFilter >= 1000) {
          return item.price >= priceFilter;
        } else {
          return products;
        }
      });
      const filterQuantity = filterPrice?.filter((item) => {
        if (quantityFilter < 1000 && quantityFilter > 0) {
          return item.waterQuantity <= quantityFilter;
        } else if (quantityFilter >= 1000) {
          return item.waterQuantity >= quantityFilter;
        } else {
          return filterPrice;
        }
      });
      const filterRating = filterQuantity?.filter((item) => {
        if (ratingFilter) {
          return item.rating === ratingFilter;
        } else {
          return filterQuantity;
        }
      });
      const filterSale = filterRating?.filter((item) => {
        if (onSale) {
          // console.log(item);
          return item.discount;
        } else {
          return filterRating;
        }
      });

      // console.log(filterSale);

      setFilterProduct(filterSale);
    }
  }, [products, isMounted, priceFilter, quantityFilter, ratingFilter, onSale]);

  // console.log(filterProduct);

  //sort products
  useEffect(() => {
    if (isMounted.current) {
      if (filterProduct?.length > 0) {
        if (sortBy === "recommended") {
          return setSortProduct([...filterProduct]);
        } else if (sortBy === "new") {
          return setSortProduct(
            [...filterProduct].sort((a, b) => a.createdAt - b.createdAt)
          );
        } else if (sortBy === "highToLow") {
          return setSortProduct(
            [...filterProduct].sort((a, b) => b.price - a.price)
          );
        } else if (sortBy === "lowToHigh") {
          return setSortProduct(
            [...filterProduct].sort((a, b) => a.price - b.price)
          );
        } else if (sortBy === "rating") {
          return setSortProduct(
            [...filterProduct].sort((a, b) => b.rating - a.rating)
          );
        } else if (sortBy === "popularity") {
          return setSortProduct(
            [...filterProduct].sort((a, b) => b.totalSales - a.totalSales)
          );
        } else if (sortBy === "atoz") {
          return setSortProduct(
            [...filterProduct].sort((a, b) => a.name.localeCompare(b.name))
          );
        } else {
          return setSortProduct(
            [...filterProduct].sort((a, b) => b.name.localeCompare(a.name))
          );
        }
      } else {
        return setSortProduct([]);
      }
    }
  }, [isMounted, filterProduct, sortBy]);

  const notFoundLottie = {
    loop: false,
    autoplay: true,
    animationData: emptyList,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  // console.log(sortProduct);

  const resetFilter = () => {
    setRatingFilter(0);
    setPriceFilter(0);
    setQuantityFilter(0);
  };

  return (
    <section className="supplier-product-section-main">
      <Grid container spacing={2} className="flex-row main-supplier-container ">
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          lg={3}
          className="supplier-main-section-left"
        >
          <div className="mobile-filter-container flex-column">
            <div className="mob-filter-main-content flex-row align-items-center gap-2 justify-content-between">
              <div className="mob-filter-content-search-bar flex-row align-items-center gap-1 w-100">
                <span className="flex-row align-items-center">
                  <Search />
                </span>
                <span className="flex-row w-100">
                  <TextField
                    placeholder="search"
                    className="mob-search w-100"
                  />
                </span>
              </div>
              <div className="mob-filter-icon flex-row align-items-center gap-1">
                <span
                  className="flex-row align-items-center"
                  onClick={() => {
                    setFilter(!filter);
                    setSort(false);
                  }}
                >
                  <FilterList />
                </span>
                <span
                  className="flex-row align-items-center"
                  onClick={() => {
                    setFilter(false);
                    setSort(!sort);
                  }}
                >
                  <Sort />
                </span>
              </div>
            </div>
          </div>
          <div
            className={`${
              filter ? " filter-padding  " : "supplier-filter-header"
            }`}
          >
            {/* <div className="supplier-total-item-avail flex-row align-items-center gap-1 ">
              <b>Recommended -</b> <p> items</p>
            </div> */}
            <div className="supplier-filter-title flex-row align-items-center justify-content-between">
              <h3 className="flex-row gap-2 align-items-center">
                FILTERS <FilterList />{" "}
              </h3>
              <h5 className="supplier-filter-title-reset" onClick={resetFilter}>
                RESET
              </h5>
            </div>
            <div className="supplier-filter-options">
              <div className="filter-by-price">
                <div className="filter-title flex-row align-items-center justify-content-between">
                  <h4>Price</h4>

                  <span> SAR {priceFilter}</span>
                </div>

                <div className="price-filter-bar">
                  <Slider
                    defaultValue={50}
                    value={priceFilter}
                    aria-label="Default"
                    valueLabelDisplay="auto"
                    min={10}
                    max={1000}
                    onChange={(event, newValue) => {
                      setPriceFilter(newValue);
                    }}
                  />
                </div>
              </div>
              <div className="filter-by-types">
                <div className="filter-title">
                  <h4> Order Types</h4>
                </div>
                <span className="filter-by-types-items flex-row  align-items-center">
                  <Checkbox
                    checked={orderTypeIndividual}
                    onClick={() => {
                      setOrderTypeIndividual(!orderTypeIndividual);
                    }}
                  />{" "}
                  <p> Individual </p>
                </span>
                <span className="filter-by-types-items flex-row  align-items-center">
                  <Checkbox
                    checked={!orderTypeIndividual}
                    onClick={() => {
                      setOrderTypeIndividual(!orderTypeIndividual);
                    }}
                  />{" "}
                  <p> Corporate </p>
                </span>
              </div>

              <div className="filter-by-quantity">
                <div className="filter-title flex-row align-items-center justify-content-between">
                  <h4>Quantity of water</h4>

                  <span> {quantityFilter + "ml"} </span>
                </div>

                <div className="quantity-filter-bar">
                  <Slider
                    defaultValue={50}
                    value={quantityFilter}
                    aria-label="Default"
                    valueLabelDisplay="auto"
                    min={100}
                    max={10000}
                    onChange={(event, newValue) => {
                      setQuantityFilter(newValue);
                    }}
                  />
                </div>
              </div>

              <div className="filter-by-ratings">
                <div className="filter-title">
                  <h4>Ratings</h4>
                </div>
                <div className="ratings-filter">
                  <Rating
                    name="simple-controlled"
                    value={ratingFilter}
                    onChange={(event, newValue) => {
                      setRatingFilter(newValue);
                    }}
                  />
                </div>
              </div>
              <div className="filter-by-sale-type">
                <div className="filter-title">
                  <h4>Type of sale</h4>
                </div>
                <span className="filter-by-sale-types-items flex-row  align-items-center">
                  <Checkbox
                    checked={onSale}
                    onClick={() => {
                      setOnSale(!onSale);
                    }}
                  />{" "}
                  <p> On sale </p>
                </span>
                <span className="filter-by-sale-types-items flex-row  align-items-center">
                  <Checkbox
                    checked={!onSale}
                    onClick={() => {
                      setOnSale(!onSale);
                    }}
                  />{" "}
                  <p> All products </p>
                </span>
              </div>
            </div>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8}
          lg={9}
          className="supplier-main-section-right"
        >
          <Container>
            <div className="supplier-container">
              <div
                className={`flex-row flex-wrap  gap-2 ${
                  sort ? " filter-padding  " : "supplier-sort-header-section  "
                }`}
              >
                <span className="flex-row gap-1 align-items-center supplier-sort-header-section-span w-100">
                  <InputLabel>Sort By</InputLabel>
                  <Select
                    value={sortBy}
                    onChange={handleSort}
                    className="supplier-sort-select w-100"
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value="recommended">
                      <p>Recommended</p>
                    </MenuItem>
                    <MenuItem value="new">
                      <p>What's new </p>
                    </MenuItem>
                    <MenuItem value="highToLow">
                      <p>Price : High to low </p>
                    </MenuItem>
                    <MenuItem value="lowToHigh">
                      <p>Price : Low to high</p>
                    </MenuItem>
                    <MenuItem value="rating">
                      <p>Customer Rating</p>
                    </MenuItem>
                    <MenuItem value="popularity">
                      <p>Popularity</p>
                    </MenuItem>
                    <MenuItem value="atoz">
                      <p>A to Z</p>
                    </MenuItem>
                    <MenuItem value="ztoa">
                      <p>Z to A</p>
                    </MenuItem>
                  </Select>
                </span>
              </div>

              <div className="supplier-display-card-section gap-1">
                {products ? (
                  sortProduct?.length > 0 ? (
                    sortProduct?.map((data, index) => {
                      return (
                        <BasicCard
                          key={index}
                          inWishlist={
                            wishList?.data?.some((item) => {
                              return item?.id === data?.id;
                            }) || false
                          }
                          inCart={
                            cartData?.data?.some((item) => {
                              return item?.id === data?.id;
                            }) || false
                          }
                          data={data}
                        />
                      );
                    })
                  ) : (
                    <div
                      className="flex-row align-items-center justify-content-center "
                      style={{ minHeight: "100vh" }}
                    >
                      <Lottie
                        options={notFoundLottie}
                        height={400}
                        width={400}
                      />
                    </div>
                  )
                ) : (
                  <div
                    className="flex-row align-items-center justify-content-center "
                    style={{ minHeight: "50vh" }}
                  >
                    <Lottie options={notFoundLottie} height={400} width={400} />
                  </div>
                )}
              </div>
            </div>
          </Container>
        </Grid>
        {sortProduct?.length > 10 && (
          <div className="supplier-footer-pagination w-100 flex-row justify-content-center">
            <Pagination
              count={Math.ceil((sortProduct?.length / 10).toFixed(2))}
              variant="outlined"
              shape="rounded"
            />
          </div>
        )}
      </Grid>
    </section>
  );
};

const SupplierInfo = ({ details }) => {
  // console.log(details);
  return (
    <section className="supplier-info-section-main">
      <Container>
        <div className="supplier-info-container flex-column align-items-center ">
          <div className="supplier-info-details flex-column align-items-center gap-1">
            <span className="supplier-info-logo">
              <img src={details?.image} alt="Supplier" />
            </span>
            <span className="supplier-info-heading">
              <p>AN ESTABLISHED COMPANY IN WATER SYSTEM </p>
            </span>
          </div>
          <div className="supplier-info-desc">
            <span> {ReactHtmlParser(details?.info)} </span>
          </div>
        </div>
      </Container>
    </section>
  );
};
